/* RootDrop: bundle picker + sticky add to cart */
(function () {
  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function paint(bundle, radio) {
    var form = document.getElementById(bundle.dataset.formId);
    var scope = bundle.closest('.product__info-container') || document;
    bundle.querySelectorAll('.ce-bundle__opt').forEach(function (opt) {
      opt.classList.toggle('is-selected', opt.contains(radio));
    });
    var price = radio.dataset.price;
    var btnText = form && form.querySelector('.product-form__submit > span');
    if (btnText && form.dataset.ceBtnPrice === '1' && !btnText.querySelector('.ce-btn-price') && form.querySelector('.product-form__submit:not([disabled])')) {
      var sp = document.createElement('span');
      sp.className = 'ce-btn-price';
      btnText.appendChild(sp);
    }
    setText(form && form.querySelector('.ce-btn-price'), price);
    setText(scope.querySelector('[data-ce-price-now]'), price);
    var compare = scope.querySelector('[data-ce-price-compare]');
    if (compare) {
      compare.textContent = radio.dataset.compare || '';
      compare.hidden = !radio.dataset.compare;
    }
    var chip = scope.querySelector('[data-ce-price-chip]');
    if (chip) {
      chip.textContent = radio.dataset.chip || chip.dataset.defaultChip || chip.textContent;
    }
    document.querySelectorAll('[data-ce-sticky-price]').forEach(function (el) { el.textContent = price; });
  }

  function selectDawnOption(bundle, packName) {
    var scope = bundle.closest('product-info') || document;
    var picker = scope.querySelector('variant-selects');
    if (!picker) return false;
    var first = picker.querySelector('fieldset, .product-form__input--dropdown');
    if (!first) return false;
    var select = first.querySelector('select');
    if (select) {
      if (select.value !== packName) {
        select.value = packName;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }
    var inputs = first.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === packName) {
        if (!inputs[i].checked) inputs[i].click();
        return true;
      }
    }
    return false;
  }

  /* 2-set pack: let the customer choose a colour for the second set.
     Saved as a line item property on the order. */
  function currentColour(bundle) {
    var picker = (bundle.closest('product-info') || document).querySelector('variant-selects');
    if (!picker) return '';
    var sets = picker.querySelectorAll('fieldset, .product-form__input--dropdown');
    var last = sets[sets.length - 1];
    if (!last) return '';
    var sel = last.querySelector('select');
    if (sel) return sel.value;
    var c = last.querySelector('input[type="radio"]:checked');
    return c ? c.value : '';
  }

  /* 2- and 3-comb packs: one colour picker per extra comb.
     Each choice is saved as a line item property on the order. */
  function initSecond(bundle, form) {
    var boxes = bundle.querySelectorAll('[data-ce-second]');
    if (!boxes.length) return null;
    var scope = bundle.closest('product-info') || document;
    var extras = Array.prototype.map.call(boxes, function (box) {
      var n = parseInt(box.dataset.ceSecond, 10) || 2;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Comb ' + n + ' colour]';
      hidden.disabled = true;
      form.appendChild(hidden);
      var ex = { n: n, box: box, hidden: hidden, touched: false, inputs: box.querySelectorAll('input[type="radio"]') };
      ex.set = function (v) {
        ex.inputs.forEach(function (i) { i.checked = i.value === v; });
        hidden.value = v;
      };
      ex.inputs.forEach(function (i) {
        i.addEventListener('change', function () { ex.touched = true; ex.set(i.value); });
      });
      return ex;
    });

    function sync() {
      var anchor = scope.querySelector('variant-selects');
      var after = anchor;
      extras.forEach(function (ex) {
        if (after && after.nextElementSibling !== ex.box) after.after(ex.box);
        after = ex.box;
      });
      var c = bundle.querySelector('input[type="radio"]:checked');
      var qty = c ? parseInt(c.dataset.qty || '1', 10) : 1;
      var sets = anchor ? anchor.querySelectorAll('fieldset') : [];
      var lastF = sets[sets.length - 1];
      var legend = lastF ? lastF.querySelector('legend') : null;
      if (legend && !legend.querySelector('[data-selected-value]')) {
        if (!legend.dataset.ceOrig) legend.dataset.ceOrig = legend.textContent.trim();
        legend.textContent = qty > 1 ? 'Comb 1 colour' : legend.dataset.ceOrig;
      }
      var first = currentColour(bundle);
      extras.forEach(function (ex) {
        var on = qty >= ex.n;
        ex.box.hidden = !on;
        ex.hidden.disabled = !on;
        ex.inputs.forEach(function (i) {
          var m = lastF && lastF.querySelector('input[value="' + i.value + '"]');
          var off = !!(m && m.classList.contains('disabled'));
          i.disabled = off;
          i.classList.toggle('disabled', off);
          if (off && i.checked) ex.touched = false;
        });
        if (on && (!ex.touched || !ex.hidden.value)) {
          var ok = Array.prototype.filter.call(ex.inputs, function (i) { return !i.disabled; });
          var pick = ok.some(function (i) { return i.value === first; }) ? first : (ok[0] ? ok[0].value : '');
          ex.set(pick);
        }
      });
    }
    return { sync: sync };
  }

  function initBundle(bundle) {
    if (bundle.dataset.ceReady) return;
    bundle.dataset.ceReady = '1';
    var form = document.getElementById(bundle.dataset.formId);
    if (!form) return;
    if (form.querySelector('.ce-btn-price')) form.dataset.ceBtnPrice = '1';
    var idInput = form.querySelector('[name="id"]');
    var radios = bundle.querySelectorAll('input[type="radio"]');
    var multi = bundle.dataset.multi === 'true';
    var chip = (bundle.closest('.product__info-container') || document).querySelector('[data-ce-price-chip]');
    if (chip && !chip.dataset.defaultChip) chip.dataset.defaultChip = chip.textContent;

    function apply(radio, fromUser) {
      if (!radio) return;
      paint(bundle, radio);
      if (multi) {
        selectDawnOption(bundle, radio.dataset.pack);
        return;
      }
      if (!idInput) return;
      idInput.value = radio.value;
      idInput.disabled = false;
      if (fromUser && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { apply(radio, true); });
    });
    var checked = bundle.querySelector('input[type="radio"]:checked') || radios[0];
    apply(checked, false);

    var second = initSecond(bundle, form);
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (second) second.sync(); });
    });
    if (second) second.sync();

    if (multi && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        var c = bundle.querySelector('input[type="radio"]:checked');
        if (c) paint(bundle, c);
        if (second) second.sync();
      });
    }
  }

  function initSticky(sticky) {
    if (sticky.dataset.ceReady) return;
    sticky.dataset.ceReady = '1';
    var mainButton = document.querySelector('product-form .product-form__submit');
    var stickyButton = sticky.querySelector('[data-ce-sticky-button]');
    if (!mainButton || !stickyButton) return;
    stickyButton.addEventListener('click', function () {
      var btn = document.querySelector('product-form .product-form__submit');
      if (btn) btn.click();
    });
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', hidden);
      sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
      stickyButton.tabIndex = hidden ? 0 : -1;
    });
    observer.observe(mainButton);
  }

  /* Keep autoplay videos playing when they scroll or slide back into view
     (Dawn pauses all media when the gallery slide changes). */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-ce-autoplay]');
    vids.forEach(function (v) {
      if (v.dataset.ceReady) return;
      v.dataset.ceReady = '1';
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.play().catch(function () {});
          else e.target.pause();
        });
      }, { threshold: 0.35 }).observe(v);
    });
  }

  function init() {
    initVideos();
    document.querySelectorAll('[data-ce-bundle]').forEach(initBundle);
    document.querySelectorAll('[data-ce-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
